/* eslint-disable eqeqeq */
import React, { FC} from "react";
import {  useRouteMatch } from "react-router-dom";

import { withProcedureWraper } from "../../../..";
import { Routes } from "../../../../../../AppRoutes";
import { Box } from "../../../../../../components/box";
import { Icon } from "../../../../../../components/icon";
import { CreateRecallToolForm } from "./create-form";
import { useHistory } from "react-router-dom";
import { EditRecallToolForm } from "./edit-form";

export const createRecallTool: FC = withProcedureWraper(() => {
  const { id } = useRouteMatch().params as any;
  const history = useHistory()
  
  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div
              className="btnBack"
              onClick={() => history.push(Routes.procedureRecallTool.path)}
            >
              <Icon.ArrowLeft />
            </div>
            {id != 0
              ? "CHỈNH SỬA YÊU CẦU THU HỒI CCDC"
              : "TẠO PHIẾU ĐỀ NGHỊ THU HỒI CCDC"}
          </div>
        </div>
        <Box title="Nội dung đề nghị">
          {id == 0 && <CreateRecallToolForm />}
          {id != 0 && <EditRecallToolForm />}
        </Box>
      </div>
    </div>
  );
});
